
import React from 'react';
import { Card } from '@/components/ui/card';
import { Profile } from '@/types/profile';
import {
  normalizeMaritalStatusDisplay,
  normalizeRelationshipTypeDisplay,
  normalizeTravelAvailabilityDisplay,
  normalizeSigiloPresencaDisplay
} from '@/utils/profileDisplayUtils';

interface ProfileRelationshipSectionProps {
  profile: Profile;
}

export const ProfileRelationshipSection: React.FC<ProfileRelationshipSectionProps> = ({ profile }) => {
  return (
    <Card className="bg-white/5 border-white/10 p-4">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-8 h-8 bg-luxury-red/20 rounded-full flex items-center justify-center">
          <span className="text-lg">💕</span>
        </div>
        <h3 className="text-white font-medium text-sm">Relacionamentos</h3>
      </div>
      <div className="grid grid-cols-1 gap-4 text-xs">
        {profile.relationship_type && (
          <div>
            <p className="text-white/60">Tipo de Conexão</p>
            <p className="text-white">{normalizeRelationshipTypeDisplay(profile.relationship_type)}</p>
          </div>
        )}
        {profile.travel_availability && (
          <div>
            <p className="text-white/60">Disponibilidade para Viajar</p>
            <p className="text-white">{normalizeTravelAvailabilityDisplay(profile.travel_availability)}</p>
          </div>
        )}
        {profile.marital_status && (
          <div>
            <p className="text-white/60">Estado Civil</p>
            <p className="text-white">{normalizeMaritalStatusDisplay(profile.marital_status)}</p>
          </div>
        )}
        {profile.sigilo_presenca && (
          <div>
            <p className="text-white/60">Sigilo sobre Presença</p>
            <p className="text-white">{normalizeSigiloPresencaDisplay(profile.sigilo_presenca)}</p>
          </div>
        )}
      </div>
    </Card>
  );
};
